import { ReactNode, useRef, useEffect, useState } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAPS_OPTIONS } from "../lib/googleMapsConfig";

interface GoogleMapWrapperProps {
  center: { lat: number; lng: number };
  zoom?: number;
  mapContainerStyle?: React.CSSProperties;
  mapOptions?: google.maps.MapOptions;
  children?: ReactNode;
  onClick?: (event: google.maps.MapMouseEvent) => void;
  mapId?: string;
  mapElementId?: string;
  onLoad?: (map: google.maps.Map) => void;
}

export default function GoogleMapWrapper({
  center,
  zoom = 13,
  mapContainerStyle = { width: "100%", height: 400 },
  mapOptions,
  children,
  onClick,
  mapId,
  mapElementId,
  onLoad,
}: GoogleMapWrapperProps) {
  const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_OPTIONS);

  const mapRef = useRef<google.maps.Map | null>(null);
  const [isApiReady, setIsApiReady] = useState(false);

  useEffect(() => {
    if (isLoaded && window.google && window.google.maps) {
      setIsApiReady(true);
    }
  }, [isLoaded]);

  if (!isLoaded || !isApiReady) return <div>Loading map...</div>;

  return (
    <GoogleMap
      id={mapElementId}
      mapContainerStyle={mapContainerStyle}
      center={center}
      zoom={zoom}
      options={{
        ...mapOptions,
        mapId,
      }}
      onLoad={(map) => {
        mapRef.current = map;
        onLoad?.(map);
      }}
      onClick={onClick}
    >
      {children}
    </GoogleMap>
  );
}
